/**
 * @file
 * Add tabs behavior using the jQuery UI library.
 */

(function ($, Drupal) {
  Drupal.behaviors.jqueryUITabs = {
    attach: function attach(context) {
      $('.js-tabs').tabs({
        activate: function( event, ui ) {
          Drupal.attachBehaviors(document, Drupal.settings);
        }
      });

      // Remove initial active-class
      $('.js-tabs .links__item.is-active').removeClass('is-active');
    }
  };
})(jQuery, Drupal);
